import { useState } from "react";
import { Check, Copy } from "lucide-react";

export function CopyableField({ value }: { value: string }) {
  const [copied, setCopied] = useState(false);
  return (
    <button
      type="button"
      onClick={async () => {
        await navigator.clipboard.writeText(value);
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
      }}
      className="flex w-full min-w-0 items-center justify-between gap-2 rounded-lg bg-ink-950 px-3 py-2 text-left font-mono text-xs text-brand-300 hover:bg-ink-900"
      title="Copiar"
    >
      <span className="truncate">{value}</span>
      {copied ? <Check className="h-3.5 w-3.5 shrink-0 text-brand-400" /> : <Copy className="h-3.5 w-3.5 shrink-0 text-ink-300" />}
    </button>
  );
}
